import React from 'react';
import RequestDatasetAccessAction from '../containers/RequestDatasetAccessAction';
import QueryDatasetAction from '../containers/QueryDatasetAction';
import DownloadDatasetActionMenu from './DownloadDatasetActionMenu';
import { DATASET_RIBBON_ITEMS_LENGTH } from '../constants';
import DatasetManageAction from '../settings/components/DatasetManageAction';
import CustomDatasetActionDropdown from '../links/components/CustomDatasetActionDropdown';
import CustomDatasetActions from '../links/components/CustomDatasetActions';
import DatasetActionsContainer from './DatasetActionsContainer';
import DatasetNotificationHistoryAction from '../notifications/components/DatasetNotificationHistoryAction';
import fetch from '../hooks/fetch';

const DatasetActionMenus = ({
  accessRequestAllowed,
  accessRequestDisabled,
  accessRequestSupported,
  actions,
  actionsReadStatus,
  allowDownload,
  allowManage,
  category,
  children,
  code,
  cohortAllowed,
  cohortDisabled,
  cohortSupported,
  dictionaryCode,
  disableDownload,
  fetchActions,
  isNew,
  name,
  notificationHistoryAllowed,
  readStatus,
  workflowKey,
}) => {
  const items = [];
  const key = `dataset_action_${code}_${category}_`;
  fetch.useFetchDatasetActions(fetchActions, category, code, readStatus, actionsReadStatus, isNew);

  if (accessRequestAllowed && accessRequestSupported) {
    items.push(<RequestDatasetAccessAction
      code={code}
      workflowKey={workflowKey}
      disabled={accessRequestDisabled}
      key={`${key}request`}
    />);
  }
  if (cohortAllowed && cohortSupported) {
    items.push(<QueryDatasetAction
      key={`${key}query`}
      code={code}
      disabled={cohortDisabled}
      dictionaryCode={dictionaryCode}
    />);
  }
  if (allowDownload) {
    items.push(<DownloadDatasetActionMenu
      key={`${key}download`}
      code={code}
      category={category}
      disabled={disableDownload}
    />);
  }
  if (notificationHistoryAllowed) { items.push(<DatasetNotificationHistoryAction code={code} key={`${key}notify`} />); }
  if (allowManage) {
    items.push(<DatasetManageAction
      key={`${key}settings`}
      code={code}
      name={name}
      category={category}
    />);
  }
  const count = items.length + (actions ? actions.length : 0);

  return (
    <DatasetActionsContainer>
      {children}
      {items}
      {actions && count <= DATASET_RIBBON_ITEMS_LENGTH && (<CustomDatasetActions actions={actions} />)}
      {actions && count > DATASET_RIBBON_ITEMS_LENGTH
      && (<CustomDatasetActionDropdown actions={actions} disabled={actions} />)}
    </DatasetActionsContainer>
  );
};

export default DatasetActionMenus;
